export const black = "#000000";
export const white = "#FFFFFF";
